import React from 'react';
import PropTypes from 'prop-types';

import {TableCell, TableRow} from "@mui/material";

import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";

import {greyishBlue100, greyishBlue600, greyishBlue800} from "assets/jss/main";

import {UserAgentUtils} from "utils/useragent";

TableHeader.propTypes = {
    headers: PropTypes.array.isRequired
};

const SortArrow = ({direction}) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
            marginLeft: '4px',
            flexShrink: 0,
            transform: direction === 'desc' ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s ease'
        }}
    >
        <path d="M12.7176 4.99421L9.30236 10.9709C8.72652 11.9786 7.27348 11.9786 6.69763 10.9709L3.28241 4.99421C2.71099 3.99422 3.43304 2.75 4.58477 2.75L11.4152 2.75C12.567 2.75 13.289 3.99422 12.7176 4.99421Z" fill={greyishBlue800} />
    </svg>
);

function TableHeader({headers}) {
    return (
        <TableRow>
            {headers.map((h, i) => (
                <TableCell
                    key={i}
                    align={h.align}
                    onClick={h.sortable ? h.onSort : undefined}
                    sx={{
                        maxHeight: '48px',
                        color: greyishBlue600,
                        fontSize: UserAgentUtils.isMobile() ? '13px' : '14px',
                        fontWeight: 400,
                        textTransform: "uppercase",
                        borderBottom: `1px solid ${greyishBlue100}`,
                        borderTop: `1px solid ${greyishBlue100}`,
                        borderLeft: i === 0 ? `1px solid ${greyishBlue100}` : 'none',
                        borderRight: i === headers.length - 1 ? `1px solid ${greyishBlue100}` : 'none',
                        borderTopLeftRadius: i === 0 ? '16px' : 0,
                        borderTopRightRadius: i === headers.length - 1 ? '16px' : 0,
                        py: '15px',
                        pl: i === 0 ? "16px" : '10px',
                        pr: i === headers.length - 1 ? "16px" : '10px',
                        lineHeight:'normal',
                        backgroundColor: "#F8F9FA",
                        cursor: h.sortable ? 'pointer' : 'default',
                        userSelect: h.sortable ? 'none' : 'auto'
                    }}
                >
                    {h.sortable ? (
                        <span style={{display: 'inline-flex', alignItems: 'center'}}>
                            {h.label}
                            <SortArrow direction={h.sortDirection} />
                        </span>
                    ) : (
                        <span style={{display: 'inline-flex', alignItems: 'center', gap: '4px'}}>
                            {h.label}
                            {h.tooltipId && <InfoTooltipIcon titleId={h.tooltipId} />}
                        </span>
                    )}
                </TableCell>
            ))}
        </TableRow>
    );
}

export default TableHeader;
